<template>
  <div class="head-wrapper">
    <div class="item-wrapper">
      <div class="item-top">今日事件</div>
      <div class="item-down">{{count.eventTodo}}/{{count.eventTotal}}</div>
    </div>
    <div class="item-wrapper">
      <div class="item-top">居民</div>
      <div class="item-down">{{count.peopleTotal}}/{{count.peopelRealname}}</div>
    </div>
    <div class="item-wrapper">
      <div class="item-top">企业</div>
      <div class="item-down">{{count.company}}</div>
    </div>
    <div class="item-wrapper">
      <div class="item-top">社工</div>
      <div class="item-down">{{count.worker}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      count:null
    }
  }
</script>

<style scoped>
  .head-wrapper{
    /*width: 1292px;*/
    width: 100%;
    height: 36%;
    background: #fff;
    display: flex;
    align-items:Center;
    border: 1px solid #fff;
    border-radius: 5px;
  }
  .item-wrapper{
    display: flex;
    flex:1;
    flex-flow: column;
    justify-content:center;
    text-align: center;
  }
  .item-top{
    padding-bottom:10px;
    font-size: 16px;
    font-weight:600
  }
  .item-down{
    font-size:33px;
    font-weight: 600;
  }
</style>
